import { Filter } from '~commonInfra/utils/Filter';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';

import { IListResource } from '../../../httpClient/resources/Resource';
import { ResourceQuery } from '../../../httpClient/resources/ResourceQuery';
import { FilterFieldNames } from '../../../spacesPlatform/models/IFilterClause';
import {
  GetDataConnectionTypesRequest,
  IGetDataConnectionTypesResult,
} from '../serverApi/GetDataConnectionTypesRequest';
import { IDataConnectionType } from '../serverApi/types/IDataConnection';

class DataConnectionTypesResource implements IListResource<IDataConnectionType> {

  private fetcher = new WebClientListResourceFetcher(
    GetDataConnectionTypesRequest,
    (result: IGetDataConnectionTypesResult) => result.dataConnectionTypes);

  public all(): ResourceQuery<IDataConnectionType> {
    return new ResourceQuery(this.fetcher);
  }

  public getByDataConnectionType(dataConnectionType: string): Promise<IDataConnectionType> {
    return this.all()
      .withFilters([Filter.stringFieldEq(FilterFieldNames.connectionType, dataConnectionType)])
      .getFirst();
  }

}

export const DataConnectionTypes = new DataConnectionTypesResource();